export class ChaseOrderStatus {
    transactionId: string;
    orderIds: string;
    amountPaid: string;
    transactionStatus: string;
    paymentMode: string;
}
